module.exports = "<div #selectContainer>\n  <select2\n    [data]=\"options\"\n    [value]=\"value\"\n    [width]=\"width\"\n    [disabled]=\"disabled\"\n    [options]=\"Options.select2Options\"\n    (valueChanged)=\"oneValueChanged($event)\"\n  ></select2>\n  <div *ngIf=\"loading\" class=\"loading-indicator\">\n    <span>Loading...</span>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/infinite-select/infinite-select.component.html
// module id = ./src/app/components/infinite-select/infinite-select.component.html
// module chunks = main